import http from '../../../http-common-super-admin';

class ShippingService {
  // ── Shipping Methods ────────────────────────────────────────────────────────
  listMethods() {
    return http.get('/kids/shipping/list');
  }
  getMethod(data) {
    return http.get('/kids/shipping/detail', { params: data });
  }
  createMethod(data) {
    return http.post('/kids/shipping/create', data);
  }
  updateMethod(data) {
    return http.post('/kids/shipping/update', data);
  }
  toggleMethodActive(data) {
    return http.post('/kids/shipping/toggle-active', data);
  }
  deleteMethod(data) {
    return http.delete('/kids/shipping/delete', { params: data });
  }

  // ── Market Rates ────────────────────────────────────────────────────────────
  addRate(data) {
    return http.post('/kids/shipping/rate/add', data);
  }
  updateRate(data) {
    return http.post('/kids/shipping/rate/update', data);
  }
  toggleRate(data) {
    return http.post('/kids/shipping/rate/toggle-active', data);
  }
  deleteRate(data) {
    return http.delete('/kids/shipping/rate/delete', { params: data });
  }
  syncStripeRate(data) {
    return http.post('/kids/shipping/rate/stripe-sync', data);
  }
}

export default new ShippingService();